import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import ProtectedRoute, { Guard } from "@/components/layout/ProtectedRoute";
import Shell from "@/components/layout/Shell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MasterData from "@/pages/MasterData";
import Mappings from "@/pages/Mappings";
import Shipments from "@/pages/Shipments";
import Purchasing from "@/pages/Purchasing";
import Reports from "@/pages/Reports";
import Inventory from "@/pages/Inventory";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";

function Protected({ children, module, adminOnly }) {
  return (
    <ProtectedRoute>
      <Shell><Guard module={module} adminOnly={adminOnly}>{children}</Guard></Shell>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected module="dashboard"><Dashboard /></Protected>} />
            <Route path="/master-data" element={<Protected module="masters"><MasterData /></Protected>} />
            <Route path="/inventory" element={<Protected module="stock"><Inventory /></Protected>} />
            <Route path="/mappings" element={<Protected module="mappings"><Mappings /></Protected>} />
            <Route path="/shipments" element={<Protected module="shipments"><Shipments /></Protected>} />
            <Route path="/purchasing" element={<Protected module="purchasing"><Purchasing /></Protected>} />
            <Route path="/reports" element={<Protected module="reports"><Reports /></Protected>} />
            <Route path="/users" element={<Protected adminOnly><Users /></Protected>} />
            <Route path="/audit" element={<Protected module="audit"><AuditLog /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}
